import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { MarvSelectComponent, MarvSelectItem, MarvSelectExternalSource } from '@marv/components';
import { StoreService } from '@app/services';

@Component({
    selector: 'app-store-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class StoreSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('STORE');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'storefront-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'storeId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'stores', required : false}) stores: Array<MarvSelectItem>;
    @Input({alias : 'itemsSelected', required : false}) itemsSelected: Map<number|string|boolean, MarvSelectItem> = new Map();
    @Input({alias : 'externalSource', required : false}) externalSource: MarvSelectExternalSource|undefined;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    
    @ViewChild(MarvSelectComponent) marvSelect : MarvSelectComponent;
    
    items: Array<MarvSelectItem> = [];
    
    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {      
        if(!this.externalSource){
            let items: Array<MarvSelectItem> = []
            if(typeof this.stores !== 'undefined'){
                items = this.stores;
            }
            else{
                let stores = StoreService.Stores;
                if(stores && stores.length > 0){
                    for(let store of stores){                        
                        items.push(new MarvSelectItem(store.name, store.code, environment.URL_LOGO_RETAILER.replace('#retailer_name#',store.retailer.name)));                        
                    }
                }
            }
            this.items = items;
        }
    }
    
    async ngOnChanges(changes: SimpleChanges) {   
        if(changes['stores'] && changes['stores'].currentValue){ 
            if(typeof this.stores !== 'undefined'){
                this.items = this.stores;
            }
        }        
    }
}
